<template>
  <section class="content" style="padding-left: 0px;padding-right: 0px;">
    <!-- ========Favourite Videos=========== -->
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <h2 class="home-topic">Favourite Videos</h2>
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="video in allVideos" v-bind:key="video.id">
            <div class="sg-str" @click="favoritVideo(video.id)">
              <i class="fa fa-star" aria-hidden="true">
              </i>
            </div>
            <router-link :to="'/videos/single-video/'+video.category_id+'/'+video.id">
              <div class="v-boxx">
                <div class="v-videoo">
                  <img :src='video.thumbnail_large'  alt="...">
                </div>
                <div class="v-content">
                  <p class="v-name two-line-overflow">{{video.name}}</p>
                  <!-- <ul class="v-name two-line-overflow2" style="padding-left:0;" >
                    <li class="badge bgg-pr"  v-for="product in video.products">
                      {{product.pro_name}}
                    </li>
                  </ul> -->
                  <p class="v-disc two-line-overflow">{{video.description}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
<!--        <div class="view-more-div">-->
<!--          <a href="" class="view-more">View More ></a>-->
<!--        </div>-->
      </div>
    </div>
    <div class="row" v-if="noContentVideos && !noContentErrorMsgVideos">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        No results found
      </div>
    </div>
    <div class="row" v-if="noContentErrorMsgVideos">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="100">
        <rect x="0" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="0" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="0" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="25%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="25%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="25%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="51%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="51%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="51%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="77%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="77%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="77%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="84" rx="2" ry="2" width="23%" height="3"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>

    <!-- ========Favourite Doucments=========== -->
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <h2 class="home-topic">Favourite Documents</h2>
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="doc in allDocuments" v-bind:key="doc.id">
            <div class="sg-str" @click="favoritDocument(doc.id)">
              <i class="fa fa-star" aria-hidden="true">
              </i>
            </div>
            <router-link :to="'/documents/single-dcument/'+doc.category_id+'/'+doc.id">
              <div class="v-boxx">
                <div class="v-videoo">
                   <img class="doc-img" v-bind:src='"https://smartapprcp.s3.ap-southeast-1.amazonaws.com/" + doc.thumbnail ' >
                </div>
                <div class="v-content">
                  <p class="v-name two-line-overflow">{{doc.name}}</p>
                  <!-- <ul class="v-name two-line-overflow2" style="padding-left:0;" >
                    <li class="badge bgg-pr"   v-for="product in doc.products">
                      {{product.pro_name}}
                    </li>
                  </ul> -->
                  <p class="v-disc two-line-overflow">{{doc.description}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
<!--        <div class="view-more-div">-->
<!--          <a href="" class="view-more">View More ></a>-->
<!--        </div>-->
      </div>
    </div>
    <div class="row" v-if="noContentDocs && !noContentErrorMsgDocuments">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        No results found
      </div>
    </div>
    <div class="row" v-if="noContentErrorMsgDocuments">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="100">
        <rect x="0" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="0" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="0" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="25%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="25%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="25%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="51%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="51%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="51%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="77%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="77%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="77%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="84" rx="2" ry="2" width="23%" height="3"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>
    <back-to-top bottom="120px" right="20px" visibleoffset="20">
      <button type="button" class="scoller-top-btn"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
  </section>
</template>
<script>
  import Alert from '../../widgets/Alert'
  import InfoBox from '../../widgets/InfoBox'
  import ProcessInfoBox from '../../widgets/ProcessInfoBox'
  import SmallBox from '../../widgets/SmallBox'
  import api from '../../../api'
  import VueContentLoading from 'vue-content-loading'
  import BackToTop from 'vue-backtotop'

  export default {
    name: 'homeView',
    components: {
      Alert,
      InfoBox,
      ProcessInfoBox,
      SmallBox,
      VueContentLoading,
      BackToTop
    },
    data() {
      return {
        allVideos: [],
        allDocuments: [],
        noContentErrorMsgVideos: true,
        noContentErrorMsgDocuments: true,
        noContentDocs: false,
        noContentVideos: false
      }
    },
    created() {
      this.getAllVideos()
      this.getAllDocuments()
    },
    methods: {
      getAllVideos() {
        this.allVideos = []
        api.request('get', '/customer/viewfavourites/videos/m')
          .then(response => {
            setTimeout(() => {
              this.allVideos = response.data.result

              if (this.allVideos.length === 0) {
                this.noContentVideos = true
              }
              this.noContentErrorMsgVideos = false
            }, 500)
          }).catch(errr => {
            this.noContentVideos = true
            this.noContentErrorMsgDocuments = false
          })
      },
      getAllDocuments() {
        this.allDocuments = []
        // this.noContentErrorMsgDocuments = true
        api.request('get', '/customer/viewfavourites/documents/m')
          .then(response => {
            setTimeout(() => {
              this.allDocuments = response.data.result

              if (this.allVideos.length === 0) {
                this.noContentVideos = true
              }
              this.noContentErrorMsgDocuments = false
            }, 500)
          }).catch(errr => {
            this.noContentVideos = true
            this.noContentErrorMsgDocuments = false
          })
      },
      favoritVideo(id) {
        this.favouriteBackendCall('videos', id)
        this.getAllVideos()
      },
      favoritDocument(id) {
        this.favouriteBackendCall('documents', id)
        this.getAllDocuments()
      },
      favouriteBackendCall(mediaType, id) {
        api.request('get', '/customer/favourite/' + mediaType + '/' + id)
          .then(response => {
            this.getAllVideos()
            this.getAllDocuments()
          })
      }
    }
  }
</script>
<style>
  @media (min-width: 320px) and (max-width: 480px) {
    .video-list-thumbs .glyphicon-play-circle {
      font-size: 35px;
      right: 36%;
      top: 27%;
    }

    .video-list-thumbs h2 {
      bottom: 0;
      font-size: 12px;
      height: 22px;
      margin: 8px 0 0;
    }
  }

  .top-right {
    position: absolute;
    top: 8px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// UserFavourite.vue?9fe43820